import { useEnum } from "@/api/services/global/enum";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { Button } from "@/components/elements/Button";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { TopPage } from "@/components/elements/TopPage";
import { USER_ACTIVE_STATUS } from "@/constants/enum";
import { AdminUserForm, AdminUserFormRef } from "@/features/admin-user/components/AdminUserForm";
import { AppRoutes } from "@/routes/config";
import { findLabelByValue } from "@/utils/object";
import { IconSend } from "@/assets/icons";
import { text } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { Box, FormControl, FormLabel, Grid, Stack, css, styled } from "@mui/material";
import { FC, useRef, useState } from "react";
import { Link } from "react-router-dom";

const StyledFormControl = styled(FormControl)`
  .MuiFormLabel-root {
    color: ${text.primary};
    margin-bottom: 4px;
    ${css(typography.cap12)};
  }
  .MuiFormLabel-asterisk {
    color: ${text.error};
  }
`;

export const AdminUserCreatePage: FC = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef<AdminUserFormRef>(null);
  const { data: activeStatuses } = useEnum("EUserActiveStatus");

  // Default status is "active" for new users
  const getStatusLabel = () => {
    return findLabelByValue(activeStatuses, USER_ACTIVE_STATUS.ACTIVE) || "使用中";
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await Promise.resolve(formRef.current?.submitForm());
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminUserCreateWrapper sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <TopPage
          title="irohana担当者の新規追加"
          description="現在のシステム管理画面にアクセスできるユーザーを作成します。送付されるメールにはURLが送付されるため、追加したユーザーに登録するようにお伝えください。"
          backUrl={AppRoutes.adminUser}
          enablePageBack={false}
        />
        <Box mt="36px">
          <MenuNavigate
            contentWidth="900px"
            contents={[
              {
                title: "ユーザーの状態",
                content: (
                  <InnerBox title="ユーザーの状態" padding={3}>
                    <Grid container columnSpacing={3} rowSpacing={2}>
                      <Grid item xs={6}>
                        <StyledFormControl fullWidth>
                          <FormLabel required>ステータス</FormLabel>
                          <Input value={getStatusLabel()} readonly />
                        </StyledFormControl>
                      </Grid>
                    </Grid>
                  </InnerBox>
                ),
              },
              {
                title: "基本情報",
                content: (
                  <InnerBox title="基本情報" padding={3}>
                    <AdminUserForm ref={formRef} />
                  </InnerBox>
                ),
              },
            ]}
            contentAffix={
              <FooterContainer sx={{ mt: 4 }}>
                <Stack gap={1} direction="row" justifyContent="space-between" alignItems="center">
                  <Button size="sm-round" variant="secondary" component={Link} to={AppRoutes.adminUser}>
                    戻る
                  </Button>
                  <Stack direction="row" gap={3}>
                    <Button disabled={loading} size="sm-round" onClick={handleSubmit} startIcon={<IconSend />}>
                      メールを送信
                    </Button>
                  </Stack>
                </Stack>
              </FooterContainer>
            }
          />
        </Box>
      </Box>
    </AdminUserCreateWrapper>
  );
};
const AdminUserCreateWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
